import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnInit,
  Optional,
} from '@angular/core';
import {
  AsyncPipe,
  NgOptimizedImage,
  NgStyle,
  NgTemplateOutlet,
  TitleCasePipe,
} from '@angular/common';
import { Router } from '@angular/router';
import { ContainerModel } from '@app/models/server/layout.model';
import { ComponentRef, OverlayEventDetail } from '@ionic/core';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { SafePipe } from '@app/components/pipes/safe/safe.pipe';
import { from, Observable, of, switchMap } from 'rxjs';
import { HttpClientService } from '@app/services/util-services/root-services/http-client.service';
import { ModalController } from '@ionic/angular/standalone';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-desktop-promo',
  templateUrl: './desktop-promo.component.html',
  styleUrls: ['./desktop-promo.component.scss'],
  standalone: true,
  imports: [
    NgOptimizedImage,
    SafePipe,
    AsyncPipe,
    TitleCasePipe,
    NgStyle,
    NgTemplateOutlet,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopPromoComponent implements OnInit {
  @Input() compData: {
    container: ContainerModel;
  };
  imgQuality = 90;

  isDesktop: boolean = this.b2bDeviceUtilService?.isDesktop();

  imgHeight = this.isDesktop ? '150px' : '300px';

  hostWebsite: string = environment.hostWebsite;

  finalContainer$: Observable<ContainerModel>;

  constructor(
    private router: Router,
    @Optional() @Inject('WINDOW') private window: any,
    private b2bDeviceUtilService: B2bDeviceUtilService,
    private modalController: ModalController,
    private httpClientService: HttpClientService,
  ) {}

  ngOnInit() {
    this.initApi();
  }

  initApi() {
    if (this.compData?.container?.apiURL) {
      this.finalContainer$ = this.httpClientService
        ?.getDynamicContainersData(
          this.compData?.container?.apiURL,
          this.compData?.container?.isCacheEnabled,
          this.compData?.container?.key,
          this.compData?.container?.apiRequestBody,
          null,
          true,
        )
        .pipe(
          switchMap((containers: ContainerModel[]) => {
            if (containers?.length === 1) {
              return of(containers[0]);
            } else {
              return of(undefined);
            }
          }),
        );
    } else {
      // this.compData.container.subType = 'wow';
      // this.compData.container.background = '#00a098';
      this.finalContainer$ = of(this.compData?.container);
    }
  }

  goto(finalContainer: ContainerModel) {
    if (finalContainer?.externalUrl && this.window) {
      this.window.open(finalContainer?.externalUrl, '_blank');
      return;
    }

    if (finalContainer?.navigationURL) {
      if (this.b2bDeviceUtilService?.isDesktop()) {
        if (this.window) {
          const finalUrl: string =
            this.window?.origin + finalContainer?.navigationURL;
          this.window.open(finalUrl, '_blank');
        }
      } else {
        // this.b2bDeviceUtilService.getToPath(finalContainer?.navigationURL);
        if (environment?.webApp) {
          this.router.navigateByUrl(finalContainer?.navigationURL).then();
        } else {
          this.router.navigateByUrl(finalContainer?.navigationURL).then();
          /*
          let currentUrlPath: string = this.router.url.toLowerCase();
          if (currentUrlPath.includes('?')) {
            currentUrlPath = currentUrlPath.substring(
              0,
              currentUrlPath.indexOf('?'),
            );
          }
          let newUrlPath: string = finalContainer?.navigationURL?.toLowerCase();
          if (newUrlPath.includes('?')) {
            newUrlPath = newUrlPath.substring(0, newUrlPath.indexOf('?'));
          }

          if (newUrlPath === currentUrlPath) {
            this.router
              .navigateByUrl(finalContainer?.navigationURL)
              .then(() => {
                this.b2bDeviceUtilService?.reloadPageInApp();
              });
            /!*if (finalContainer?.navigationURL?.includes('?')) {
              finalContainer.navigationURL =
                finalContainer?.navigationURL + '&switch=1';
            } else {
              finalContainer.navigationURL =
                finalContainer.navigationURL + '?switch=1';
            }*!/

            // this.router.navigateByUrl(finalContainer?.navigationURL).then();
          } else {
            this.router.navigateByUrl(finalContainer?.navigationURL).then();
          }*/
        }
      }
    }
    if (finalContainer?.type === 'SIGNUP') {
      this.openLoginPopup()?.then();
    }
    if (finalContainer?.type === 'ENQUIRE_NOW') {
      this.openContactUsForm();
    }
  }

  gotoMembership() {
    this.router.navigateByUrl('/membership').then();
  }

  async openLoginPopup() {
    const module = await import('@b2b/auth-lib');

    const componentProps: {
      compData: {
        pageType: string;
        isModal: boolean;
        disablePageNavigation: boolean;
      };
    } = {
      compData: {
        pageType: 'login',
        isModal: true,
        disablePageNavigation: true,
      },
    };

    const modal: HTMLIonModalElement = await this.modalController.create({
      component: module.AuthModalComponent,
      componentProps,
      initialBreakpoint: 1,
      breakpoints: this.isDesktop ? null : [0, 1],
      cssClass: 'auth-modal',
    });

    modal.onDidDismiss().then((result: OverlayEventDetail<{}>) => {
      // LoggerService.log('Login popup ', result.data);
      if (result && result?.data) {
      }
    });
    return await modal.present();
  }

  openContactUsForm() {
    from(
      import(
        '@app/new-ui-lib/b2b-cards/components/b2b-contact-us-form-card/b2b-contact-us-form-card.component'
      ).then((c) => c.B2bContactUsFormCardComponent),
    ).subscribe({
      next: async (componentRef: ComponentRef) => {
        const modal: HTMLIonModalElement = await this.modalController.create({
          component: componentRef,
          // initialBreakpoint: this.isDesktop ? null : 1,
          breakpoints: this.isDesktop ? null : [0, 1],
          cssClass: 'enquiry-modal',
        });

        modal.onDidDismiss().then((result: OverlayEventDetail<any>) => {});

        return await modal.present();
      },
    });
  }
}
